<template>
<div>
    <!-- fixed-bottom-nav -->
    <div class="bottombar-large" style="margin-top:5em; margin-left: -2em; width: 400px;">
        <div style="padding-left:1em;">
            <a href="/"><i class="fa fa-list"></i><br><span>Feeds</span></a>
            <a href="/shop"><i class="fa fa-shopping-bag"></i><br><span>Bag</span></a>
            <a href="/account"><i class="fa fa-search"></i><br><span>Account</span></a>
            <a href="/notifications"><i class="fa fa-bell"></i><sup v-if="notifications_alert > 0" class="notify-alert">{{notifications_alert}}</sup><br><span>Notifications</span></a>
            <a href="/cart"><i class="fa fa-user"></i><br><span>Account</span></a>
            <!-- <a href="#news" style="font-size:22px;"><i class="fa fa-plus"></i><span>Add</span></a> -->
        </div>
    </div>

    <!---mobile-->
    <!-- <div class="bottombar" style="margin-top:15em; margin-left: -2em;width: 150%;"> -->
    <div class="bottombar" style="background:#f0d803 !important; border-bottom:2px solid #000000;">
        <!-- <div style="margin-left:2.5em;"> -->
        <div>
            <a href="/"><i id="m_trending" class="fa fa-list"></i><br><span>Trending</span></a>
            <a href="cart" ><i id="m_cart" class="fa fa-shopping-bag"></i><br><span>Bag</span></a>
            <!--<a href="#"><i id="m_search" class="fa fa-search"></i><br><span>Search</span></a>-->
            <a href="/feeds"><i id="m_feeds" class="fa fa-star"></i><br><span>Feeds</span></a>
            <a href="/notifications"><i id="m_notifications" class="fa fa-bell"></i><sup v-if="notifications_alert > 0" class="notify-alert">{{notifications_alert}}</sup><br><span>Notifications</span></a>
            <a href="/account"><i id="m_account" class="fa fa-user"></i><br><span>Account</span></a>
        </div>
    </div>
    <!--./mobile-->
   
    <!--./ fixed-bottom-nav -->
 </div>
</template>

<style>
    .notify-alert{
        background: #ff0066;
        color: #ffffff;
        font-size: 11px;
        padding: 0.2em 0.42em;
        border-radius: 50%;
    }
</style>


<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'MenuBottom',
    data () {
        return {
            user:{},
            notifications:{},
            notifications_alert:0,
        }
    },

    methods: {
        preset() {
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.getNotifications();
                }else {
                    // self.$router.push('login');
                }
            });
        },

        getNotifications(){
            service.getNotifications(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.notifications_alert = response.body.data_alert_total;
                }
            }).catch((err) => {})
        },
    },

    mounted: function() {
        let path = this.$route.path;
        // if(path == "/"){document.getElementById("m_trending").style.color = "#ff0066";}
        // if(path == "/cart"){document.getElementById("m_cart").style.color = "#ff0066";}
        // if(path == "/search"){document.getElementById("m_search").style.color = "#ff0066";}
        // if(path == "/feeds"){document.getElementById("m_feeds").style.color = "#ff0066";}
        // if(path == "/notifications"){document.getElementById("m_notifications").style.color = "#ff0066";}
        // if(path == "/account"){document.getElementById("m_account").style.color = "#ff0066";}

        //color change
        if(path == "/"){document.getElementById("m_trending").style.color = "#f9072e";}
        if(path == "/cart"){document.getElementById("m_cart").style.color = "#f9072e";}
        if(path == "/search"){document.getElementById("m_search").style.color = "#f9072e";}
        if(path == "/feeds"){document.getElementById("m_feeds").style.color = "#f9072e";}
        if(path == "/notifications"){document.getElementById("m_notifications").style.color = "#f9072e";}
        if(path == "/account"){document.getElementById("m_account").style.color = "#f9072e";}
    },
    created: function() {
        // this.notifications.alert_no = 5;
        this.preset();
    }
}
</script>


// WEBPACK FOOTER //
// menubottom.vue?90bac8f6